export default __webpack_public_path__ + "static/media/fdds_big.c36c72af.png";